import {getToken, setToken, removeToken} from '@/utils/auth'
import router  from '@/router'
import {userLogin, getAdminInfo, loginOut} from "@/api"
import {Message} from "element-ui"

const getDefaultState = () => {
    return {
        token: getToken(),
        name: '',
        avatar: '',
        socket_data: {},
    }
}

const state = getDefaultState()

const mutations = {
    SET_TOKEN: (state, token) => {
        state.token = token
    },
    SET_NAME: (state, name) => {
        state.name = name
    },
    SET_AVATAR: (state, avatar) => {
        state.avatar = avatar
    },
    SET_WEBSOCKET: (state, avatar) => {
        state.socket_data = avatar
    },
}

const actions = {
    set_socket({commit, state}) {
        commit('SET_WEBSOCKET', state)
    },

    // 普通登录
    login({commit}, params) {
        return new Promise((resolve, reject) => {
            userLogin(params).then(async ({data}) => {
                if (data.activation_status === "ACTIVATED" && data.level==='success') {
                    setToken(data.data)
                    await this.dispatch('user/getAdminInfo')
                    Message.success('登录成功 !')
                    resolve(data)
                } else {
                    console.log('else')
                  resolve(data)
                }
            }).catch(error => {
                reject(error)
            })
        })
    },

    // 获取管理员信息
    getAdminInfo() {
        return new Promise((resolve, reject) => {
            getAdminInfo().then(({data}) => {
                if (data.activation_status === "ACTIVATED") {
                    this.commit('user/SET_NAME', data.data.username)
                    this.commit('user/SET_AVATAR', data.data.admin_name)
                    resolve(data)
                }
            }).catch(error => {
                reject(error)
            })
        })
    },

    // 退出登录
    loginOut({commit, state}) {
        return new Promise((resolve, reject) => {
            loginOut().then(() => {
                removeToken()
                router.replace('/login')
                Message.success('退出成功 !')
                resolve()
            }).catch(error => {
                reject(error)
            })
        })
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}

